import React from 'react'
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core'

import ClientContext from 'contexts/ClientContext'

export default function Type() {
  const { data, handleChange, setFormId, nextStep } = React.useContext(
    ClientContext,
  )
  const formId = 'formStepType'

  React.useEffect(() => {
    setFormId(formId)
  }, [setFormId])

  const handleSubmit = e => {
    e.preventDefault()
    nextStep()
  }

  return (
    <form onSubmit={handleSubmit} id={formId}>
      <FormControl component="fieldset">
        <FormLabel component="legend">Escolha o tipo</FormLabel>
        <RadioGroup
          aria-label="kind"
          name="kind"
          value={data.kind}
          onChange={handleChange}
        >
          <FormControlLabel
            value="P"
            control={<Radio />}
            label="Pessoa Física"
          />
          <FormControlLabel
            value="C"
            control={<Radio />}
            label="Pessoa Jurídica"
          />
        </RadioGroup>
      </FormControl>
    </form>
  )
}
